export const usePath = () => {
  const pathname = window.location.pathname
  const paths = pathname
    .split('/')
    .slice(1)
    .map((location) => decodeURIComponent(location))

  // Replace "home" with "Dacr"
  paths[0] = 'Dacr'

  return paths
}
